import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";

import { toast } from "react-toastify";
import * as api from "../../redux/api";
import Spinner from "../loaders/Spinner";
import { isYupError, parseYupError } from "../../utils/Yup";
import { getValidationSchema } from "../../utils/validation";

const PurchaseRequestStatusChange = ({ handleClose, open, statusType, id }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [text, setText] = useState("");
  const [formError, setFormError] = useState({});
  const handleSubmit = async () => {
    // if (text.length < 1) {
    //   toast.error("Input field should not be empty");
    //   return;
    // }
    try {
      setFormError({});
      const schema = getValidationSchema(statusType);
      await schema.validate({ text }, {
        abortEarly: false,
      });
      const res = await api.changePurchaseRequestStatus(id, {
        status: statusType,
        narration: text,
      });
      const { status, data } = res;
      if (status >= 200 && status < 300) {
        setIsLoading(false);
        toast.success("Changed Successfully");
        handleClose();
        setText("");
        setFormError({});
      } else {
        setIsLoading(false);
        toast.error(data.message);
      }
    }
    catch (error) {
      if (isYupError(error)) {
        setFormError(parseYupError(error));
      } else {
        console.log(error, "error");
        toast.error(error?.response?.data?.message);
      }
      setIsLoading(false);
    }
  };
  const renderLabel = (type) => {
    if (type === "Processed") {
      return "Assigned To:";
    } else if (type === "Rejected") {
      return "Reason:";
    } else if (type === "Completed") {
      return "Transaction Hash";
    }
  };
  const renderPlaceholder = (type) => {
    if (type === "Processed") {
      return "Enter name";
    } else if (type === "Rejected") {
      return "Enter specific reason";
    } else if (type === "Completed") {
      return "Enter hash";
    }
  };
  return (
    <>
      {isLoading && <Spinner />}
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        fullWidth={true}
        maxWidth={"sm"}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {" "}
          <h4 className=" text-center">Change Status </h4>
        </DialogTitle>
        <DialogContent dividers={"paper"}>
          <div className="w-full min-h-[250px] ">
            <div className="">
              <strong>{renderLabel(statusType)}</strong>
              <div>
                <input
                  type="text"
                  placeholder={renderPlaceholder(statusType)}
                  className="flex-1"
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                />
                {formError.text && (
                  <div className="form-eror">{formError.text}</div>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            type="button"
            onClick={handleSubmit}
            className={`btn btn-primary `}
          >
            Submit
          </button>
          <button
            type="button"
            onClick={handleClose}
            className={`btn btn-danger `}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PurchaseRequestStatusChange;
